package org.example.zone360.pages.coachDetails.sessionAllDetails.customHighlight

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.rowGap
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.example.zone360.components.CommonButton
import org.example.zone360.components.CustomSpacer
import org.example.zone360.components.KeywordInput
import org.example.zone360.components.OptionalInputField
import org.example.zone360.components.ResizableTextAreaField
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.CustomHighlightRequest
import org.example.zone360.models.CustomKeyword
import org.example.zone360.models.GetClubCoachesData
import org.example.zone360.models.GetClubPlayerData
import org.example.zone360.models.GetSentencesData
import org.example.zone360.models.GetSessionsData
import org.example.zone360.pages.coachDetails.sessionAllDetails.CoachTokenSearch
import org.example.zone360.pages.coachDetails.sessionAllDetails.PlayerTokenSearch
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Res
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.HTMLTextAreaElement
import org.example.zone360.utils.saveCustomHighlight
import kotlin.math.min


@Composable
fun CustomHighlight(
    onDialogDismiss: () -> Unit,
    onSave: () -> Unit,
    breakpoint: Breakpoint,
    sitePalette: SitePalette,
    sessionData: GetSessionsData,
    toastMessageCall: (String) -> Unit,
    sessionDuration: Double,
    seekTimeFromClick: Double?,
    setSeekTimeFromClick: (Double?) -> Unit,
    seekKey: Long,
    player: List<GetClubPlayerData>,
    coach: List<GetClubCoachesData>,
    getSentencesList: List<GetSentencesData>,
    sliderStartTime: Double,
    sliderEndTime: Double,
    onStartTimeChange: (Double) -> Unit,
    onEndTimeChange: (Double) -> Unit,
    originalAudio: Boolean,
) {
    val scope = rememberCoroutineScope()
    // 🧠 Manage Field States
    val startMinutes = remember { mutableStateOf("") }
    val startSeconds = remember { mutableStateOf("") }
    val endMinutes = remember { mutableStateOf("") }
    val endSeconds = remember { mutableStateOf("") }
    val wasStartManuallyEdited = remember { mutableStateOf(false) }
    val wasEndManuallyEdited = remember { mutableStateOf(false) }

    var isLoading by remember { mutableStateOf(false) }
    var isStartMinutesError by remember { mutableStateOf(false) }
    var isEndMinutesError by remember { mutableStateOf(false) }
    var isStartSecError by remember { mutableStateOf(false) }
    var isEndSecError by remember { mutableStateOf(false) }
    var keywordError by remember { mutableStateOf(false) }
    var transcriptError by remember { mutableStateOf(false) }
    val selectedPlayers = remember { mutableStateListOf<GetClubPlayerData>() }
    var transcriptText by remember { mutableStateOf("") }
    val keywordsList = remember { mutableStateListOf<String>() }
    var keywordInputText by remember { mutableStateOf("") }
    val selectedCoach = remember { mutableStateListOf<GetClubCoachesData>() }
    var keywordErrorText by remember { mutableStateOf("") }
    val heightPx = remember { mutableStateOf(0.px) }
    if (window.screen.width > 650) {
        LaunchedEffect(Unit) {
            heightPx.value = 400.px
        }
    }

    LaunchedEffect(Unit) {

        if (sliderStartTime == 0.0 && sliderEndTime == 0.0 && sessionDuration > 0) {
            val endTime = min(30.0, sessionDuration)
            onStartTimeChange(0.0)
            onEndTimeChange(endTime)

            // ✅ Don't wait for parent to propagate — set fields directly here
            val endMin = (endTime / 60).toInt().toString()
            val endSec = (endTime % 60).toInt().toString()

            startMinutes.value = "0"
            startSeconds.value = "0"
            endMinutes.value = endMin
            endSeconds.value = endSec

            (document.getElementById(Res.Id.startMinute) as? HTMLInputElement)?.value = "0"
            (document.getElementById(Res.Id.startSeconds) as? HTMLInputElement)?.value = "0"
            (document.getElementById(Res.Id.endMinute) as? HTMLInputElement)?.value = endMin
            (document.getElementById(Res.Id.endSeconds) as? HTMLInputElement)?.value = endSec
        } else {
        }
    }
    LaunchedEffect(sliderStartTime, sliderEndTime) {
        // ✅ Skip if both are 0 — LaunchedEffect(Unit) will handle the default range
        if (sliderStartTime == 0.0 && sliderEndTime == 0.0) return@LaunchedEffect
        val startMin = (sliderStartTime / 60).toInt().toString()
        val startSec = (sliderStartTime % 60).toInt().toString()
        val endMin = (sliderEndTime / 60).toInt().toString()
        val endSec = (sliderEndTime % 60).toInt().toString()

        // ✅ Always update input fields regardless of previous manual edit
        startMinutes.value = startMin
        startSeconds.value = startSec
        endMinutes.value = endMin
        endSeconds.value = endSec

        // ✅ Force DOM sync
        (document.getElementById(Res.Id.startMinute) as? HTMLInputElement)?.value = startMin
        (document.getElementById(Res.Id.startSeconds) as? HTMLInputElement)?.value = startSec
        (document.getElementById(Res.Id.endMinute) as? HTMLInputElement)?.value = endMin
        (document.getElementById(Res.Id.endSeconds) as? HTMLInputElement)?.value = endSec

        // ✅ Reset manual flags so future slider moves update correctly
        wasStartManuallyEdited.value = false
        wasEndManuallyEdited.value = false
    }

    LaunchedEffect(seekKey) {
        seekTimeFromClick?.let { seekTime ->
            val audioDuration = sessionDuration.toInt()
            if (seekTime < 0 || seekTime >= audioDuration) return@LaunchedEffect

            val startTotalSeconds = seekTime.toInt()
            val endTotalSeconds = min(startTotalSeconds + 15, audioDuration)

            val newStartMin = (startTotalSeconds / 60).toString()
            val newStartSec = (startTotalSeconds % 60).toString()
            val newEndMin = (endTotalSeconds / 60).toString()
            val newEndSec = (endTotalSeconds % 60).toString()

            // ✅ Update state
            startMinutes.value = newStartMin
            startSeconds.value = newStartSec
            endMinutes.value = newEndMin
            endSeconds.value = newEndSec

            // ✅ FORCE the field DOM value directly (to fix UI update delay)
            (document.getElementById(Res.Id.startMinute) as? HTMLInputElement)?.value = newStartMin
            (document.getElementById(Res.Id.startSeconds) as? HTMLInputElement)?.value = newStartSec
            (document.getElementById(Res.Id.endMinute) as? HTMLInputElement)?.value = newEndMin
            (document.getElementById(Res.Id.endSeconds) as? HTMLInputElement)?.value = newEndSec
        }
    }

    LaunchedEffect(startMinutes.value, startSeconds.value, endMinutes.value, endSeconds.value) {
        val startMin = startMinutes.value.toIntOrNull() ?: 0
        val startSec = startSeconds.value.toIntOrNull() ?: 0
        val endMin = endMinutes.value.toIntOrNull() ?: 0
        val endSec = endSeconds.value.toIntOrNull() ?: 0

        val startTotalSeconds = (startMin * 60) + startSec
        val endTotalSeconds = (endMin * 60) + endSec

        onStartTimeChange(startTotalSeconds.toDouble())
        onEndTimeChange(endTotalSeconds.toDouble())

        val transcript = getTranscriptFromSentences(
            sentences = getSentencesList,
            startTime = startTotalSeconds.toDouble(),
            endTime = endTotalSeconds.toDouble()
        )

        if (transcript.isNotBlank()) {
            transcriptText = transcript
        } else {
            transcriptText = ""
        }
    }
    LaunchedEffect(getSentencesList.size) {
        if (getSentencesList.isEmpty()) return@LaunchedEffect
        if (sliderEndTime <= sliderStartTime) return@LaunchedEffect

        val transcript = getTranscriptFromSentences(
            sentences = getSentencesList,
            startTime = sliderStartTime,
            endTime = sliderEndTime
        )

        if (transcript.isNotBlank()) {
            transcriptText = transcript
            (document.getElementById(Res.Id.transcript) as? HTMLTextAreaElement)?.value = transcript
        }
    }

    val existingKeywords = remember(getSentencesList) {
        getSentencesList
            .flatMap { it.keywords ?: emptyList() }
            .map { it.text.trim().lowercase() }
            .toSet()
    }


    scope.launch {
        delay(100)
        (document.getElementById(Res.Id.transcript) as? HTMLTextAreaElement)?.let { textArea ->
            textArea.value = transcriptText
        }
    }

    fun clearFields() {
        // Reset time fields from both manual and seekbar selection
        startMinutes.value = ""
        startSeconds.value = ""
        endMinutes.value = ""
        endSeconds.value = ""

        wasStartManuallyEdited.value = false
        wasEndManuallyEdited.value = false

        setSeekTimeFromClick(null)
        // Reset other fields
        (document.getElementById(Res.Id.transcript) as? HTMLTextAreaElement)?.value = ""
        (document.getElementById(Res.Id.note) as? HTMLInputElement)?.value = ""
        keywordsList.clear()

        // Ensure DOM values are cleared as well
        (document.getElementById(Res.Id.startMinute) as? HTMLInputElement)?.value = ""
        (document.getElementById(Res.Id.startSeconds) as? HTMLInputElement)?.value = ""
        (document.getElementById(Res.Id.endMinute) as? HTMLInputElement)?.value = ""
        (document.getElementById(Res.Id.endSeconds) as? HTMLInputElement)?.value = ""

        // Clear the parent slider time
        onStartTimeChange(0.0)
        onEndTimeChange(0.0)
    }

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .then(
                if (window.screen.width > 650) Modifier.height(heightPx.value) else Modifier
            )
            .transition(
                Transition.of("height", 500.ms, AnimationTimingFunction.EaseInOut)
            )
            .overflow(Overflow.Auto)
    )
    {
        Column(
            modifier = Modifier.width(100.percent)
                .height(100.percent)
                .gap(15.px)
        ) {
            Row(
                modifier = Modifier.fillMaxWidth().flexWrap(FlexWrap.Wrap),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Column(modifier = Modifier.fillMaxWidth(if (window.screen.width < 650) 100.percent else 49.percent)) {
                    Row(
                        modifier = Modifier.fillMaxWidth().flexWrap(FlexWrap.Wrap),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        val track =
                            if (sessionData.videoFile.isNotEmpty()) "video track" else "audio track"
                        Column(
                            Modifier.fillMaxWidth(49.percent)
                                .gap(4.px)
                        ) {
                            FieldTitleTextNormalSimple("Start Time", fontSize = 14.px)
                            Row(
                                modifier = Modifier.fillMaxWidth().gap(8.px),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                OptionalInputField(
                                    id = Res.Id.startMinute,
                                    value = startMinutes.value,
                                    leftPadding = 5.px,
                                    rightPadding = 5.px,
                                    isError = isStartMinutesError,
                                    errorText = "",
                                    number = true,
                                    placeHolder = "mm",
                                    onValueChange = { text ->
                                        if (text.all { it.isDigit() } || text.isEmpty()) {
                                            console.log("✏️ StartMinute Input: $text")
                                            startMinutes.value = text
                                            wasStartManuallyEdited.value = true
                                            isStartMinutesError = false
                                        }
                                    },
                                    onEnterPress = { oldValue ->
                                        validateStartAndEndTime(
                                            startMinutes,
                                            startSeconds,
                                            endMinutes,
                                            endSeconds,
                                            sessionDuration,
                                            isStartEdited = true

                                        )
                                        oldValue
                                    },
                                    onFocusChanged = { isFocused ->
                                        if (!isFocused) {
                                            validateStartAndEndTime(
                                                startMinutes,
                                                startSeconds,
                                                endMinutes,
                                                endSeconds,
                                                sessionDuration,
                                                isStartEdited = true

                                            )
                                        }
                                    },
                                    inputType = InputType.Text,
                                    width = 50.px,
                                    height = 50.px,
                                    textAlign = TextAlign.Center,
                                    backgroundColor = sitePalette.lightGrey.rgb
                                )

                                FieldTitleTextNormalSimple(":", fontSize = 14.px)
                                OptionalInputField(
                                    id = Res.Id.startSeconds,
                                    value = startSeconds.value,
                                    leftPadding = 5.px,
                                    rightPadding = 5.px,
                                    isError = isStartSecError,
                                    number = true,
                                    placeHolder = "ss",
                                    onValueChange = { text ->
                                        if (text.all { it.isDigit() } || text.isEmpty()) {
                                            console.log("✏️ StartSecond Input: $text")
                                            startSeconds.value = text
                                            wasStartManuallyEdited.value = true
                                            isStartSecError = false
                                        }
                                    },
                                    onEnterPress = { oldValue ->
                                        validateStartAndEndTime(
                                            startMinutes,
                                            startSeconds,
                                            endMinutes,
                                            endSeconds,
                                            sessionDuration,
                                            isStartEdited = true
                                        )
                                        oldValue
                                    },
                                    onFocusChanged = { isFocused ->
                                        if (!isFocused) {
                                            validateStartAndEndTime(
                                                startMinutes,
                                                startSeconds,
                                                endMinutes,
                                                endSeconds,
                                                sessionDuration,
                                                isStartEdited = true
                                            )
                                        }
                                    },
                                    inputType = InputType.Text,
                                    width = 50.px,
                                    height = 50.px,
                                    textAlign = TextAlign.Center,
                                    backgroundColor = sitePalette.lightGrey.rgb
                                )
                            }
                            if (isStartMinutesError || isStartSecError) {
                                FieldTitleTextNormalSimple(
                                    "Please enter start time or click on the $track",
                                    color = sitePalette.textErrorColor.rgb,
                                    fontSize = 11.px,
                                    marginTop = 3.px
                                )
                            }

                        }

                        Column(
                            Modifier.fillMaxWidth(49.percent)
                                .gap(4.px)
                        ) {
                            FieldTitleTextNormalSimple("End Time", fontSize = 14.px)
                            Row(
                                modifier = Modifier.fillMaxWidth().gap(8.px),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                OptionalInputField(
                                    id = Res.Id.endMinute,
                                    value = endMinutes.value,
                                    leftPadding = 5.px,
                                    rightPadding = 5.px,
                                    placeHolder = "mm",
                                    number = true,
                                    isError = isEndMinutesError,
                                    onValueChange = { text ->
                                        if (text.all { it.isDigit() } || text.isEmpty()) {
                                            console.log("✏️ endMinute Input: $text")
                                            endMinutes.value = text
                                            wasEndManuallyEdited.value = true
                                            isEndMinutesError = false
                                        }
                                    },
                                    onEnterPress = { oldValue ->
                                        validateStartAndEndTime(
                                            startMinutes,
                                            startSeconds,
                                            endMinutes,
                                            endSeconds,
                                            sessionDuration
                                        )
                                        oldValue
                                    },
                                    onFocusChanged = { isFocused ->
                                        if (!isFocused) {
                                            validateStartAndEndTime(
                                                startMinutes,
                                                startSeconds,
                                                endMinutes,
                                                endSeconds,
                                                sessionDuration
                                            )
                                        }
                                    },
                                    inputType = InputType.Text,
                                    width = 50.px,
                                    height = 50.px,
                                    textAlign = TextAlign.Center,

                                    backgroundColor = sitePalette.lightGrey.rgb
                                )
                                FieldTitleTextNormalSimple(":", fontSize = 14.px)
                                // End Seconds
                                OptionalInputField(
                                    id = Res.Id.endSeconds,
                                    value = endSeconds.value,
                                    leftPadding = 5.px,
                                    rightPadding = 5.px,
                                    number = true,
                                    isError = isEndSecError,
                                    placeHolder = "ss",
                                    textAlign = TextAlign.Center,
                                    onValueChange = { text ->
                                        if (text.all { it.isDigit() } || text.isEmpty()) {
                                            console.log("✏️ endSeconds Input: $text")
                                            endSeconds.value = text
                                            wasEndManuallyEdited.value = true
                                            isEndSecError = false
                                        }
                                    },
                                    onEnterPress = { oldValue ->
                                        validateStartAndEndTime(
                                            startMinutes,
                                            startSeconds,
                                            endMinutes,
                                            endSeconds,
                                            sessionDuration
                                        )
                                        oldValue
                                    },
                                    onFocusChanged = { isFocused ->
                                        if (!isFocused) {
                                            validateStartAndEndTime(
                                                startMinutes,
                                                startSeconds,
                                                endMinutes,
                                                endSeconds,
                                                sessionDuration
                                            )
                                        }
                                    },
                                    inputType = InputType.Text,
                                    width = 50.px,
                                    height = 50.px,
                                    backgroundColor = sitePalette.lightGrey.rgb
                                )
                            }
                            if (isEndMinutesError || isEndSecError) {
                                FieldTitleTextNormalSimple(
                                    "Please enter end time or click on the $track",
                                    color = sitePalette.textErrorColor.rgb,
                                    fontSize = 11.px,
                                    marginTop = 3.px

                                )
                            }

                        }
                    }

                }

                Column(modifier = Modifier.fillMaxWidth(if (window.screen.width < 650) 100.percent else 49.percent)) {

                    FieldTitleTextNormalSimple(
                        "Keywords",
                        fontSize = 14.px,
                        marginTop = 10.px,
                        marginBottom = 5.px
                    )
                    KeywordInput(
                        keywords = keywordsList,
                        inputValue = keywordInputText,
                        onInputValueChange = { keywordInputText = it },
                        isError = keywordError,
                        onKeywordAdded = {
                            keywordError = false
                        },

                        )
                    if (keywordError) {
                        CustomSpacer(height = 4.px)
                        FieldTitleTextNormalSimple(
                            keywordErrorText,
                            color = sitePalette.textErrorColor.rgb,
                            fontSize = 11.px
                        )
                    }

                }
            }

            Row(
                modifier = Modifier.fillMaxWidth().flexWrap(FlexWrap.Wrap)
                    .rowGap(10.px),
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Column(modifier = Modifier.fillMaxWidth(if (breakpoint < Breakpoint.SM) 100.percent else 49.percent)) {
                    FieldTitleTextNormalSimple(
                        "Transcript",
                        fontSize = 14.px,
                        marginBottom = 5.px
                    )
                    ResizableTextAreaField(
                        placeholder = "Transcript",
                        id = Res.Id.transcript,
                        isError = transcriptError,
                        errorText = "Please add transcript",
                        width = 100.percent,
                        minHeight = 90.px,
                        resize = false
                    )

                }
                Column(modifier = Modifier.fillMaxWidth(if (breakpoint < Breakpoint.SM) 100.percent else 49.percent)) {

                    FieldTitleTextNormalSimple("Notes", fontSize = 14.px, marginBottom = 5.px)
                    ResizableTextAreaField(
                        id = Res.Id.note,
                        width = 100.percent,
                        minHeight = 90.px,
                        placeholder = "Add your notes",
                        resize = false
                    )

                }
            }
            Row(
                modifier = Modifier.fillMaxWidth().flexWrap(FlexWrap.Wrap).rowGap(10.px),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Column(modifier = Modifier.fillMaxWidth(if (breakpoint < Breakpoint.SM) 100.percent else 49.percent)) {
                    FieldTitleTextNormalSimple(
                        "Tag Coach",
                        fontSize = 14.px,
                        marginBottom = 5.px
                    )

                    CoachTokenSearch(
                        sitePalette = sitePalette,
                        breakpoint = breakpoint,
                        backgroundColor = sitePalette.modalBackgroundColor.rgb,
                        tokenBackgroundColor = sitePalette.textFieldBorderColor.rgb,
                        minWidth = 100.percent,
                        coaches = coach,
                        currentCoachId = sessionData.userId,
                        selectedCoachesList = selectedCoach,
                        onCoachSelected = { _, coachSelected ->
                            if (selectedCoach.none { it.userId == coachSelected.userId } &&
                                coachSelected.userId != sessionData.userId
                            ) {
                                selectedCoach.add(coachSelected)
                            }
                        },

                        onCoachRemoved = { _, removedCoach ->
                            selectedCoach.removeAll { it.userId == removedCoach.userId }
                        },
                        sentenceId = "",
                        apiHit = false,
                        openUpward = true
                    )
                }
                Column(modifier = Modifier.fillMaxWidth(if (breakpoint < Breakpoint.SM) 100.percent else 49.percent)) {
                    FieldTitleTextNormalSimple(
                        "Tag Player",
                        fontSize = 14.px,
                        marginBottom = 5.px
                    )
                    PlayerTokenSearch(
                        sitePalette = sitePalette,
                        breakpoint = breakpoint,
                        backgroundColor = sitePalette.modalBackgroundColor.rgb,
                        tokenBackgroundColor = sitePalette.textFieldBorderColor.rgb,
                        minWidth = 100.percent,
                        players = player,
                        selectedPlayersList = selectedPlayers, // ✅ CONNECT selected players list
                        onPlayerSelected = { _, selectedPlayer ->
                            if (selectedPlayers.none { it.uid == selectedPlayer.uid }) {
                                selectedPlayers.add(selectedPlayer)
                            }
                        },
                        onPlayerRemoved = { _, removedPlayer ->
                            selectedPlayers.removeAll { it.uid == removedPlayer.uid }
                        },
                        sentenceId = "",
                        apiHit = false,
                        openUpward = true
                    )
                }
            }
            Row(
                modifier = Modifier.fillMaxWidth()
                    .gap(10.px).padding(right = 10.px),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.End
            ) {
                CommonButton(
                    text = "Cancel",
                    width = 80.px,
                    height = 32.px,
                    borderColor = sitePalette.primary.rgb,
                    backgroundColor = Colors.Transparent,
                    textSpanColor = sitePalette.primary.rgb,
                    onCLick = {

                        onDialogDismiss()
                        clearFields()
                    }
                )

                CommonButton(
                    text = "Submit",
                    isLoading = isLoading,
                    onCLick = {
                        scope.launch {
                            val startMin = startMinutes.value.toIntOrNull() ?: 0
                            val startSec = startSeconds.value.toIntOrNull() ?: 0
                            val endMin = endMinutes.value.toIntOrNull() ?: 0
                            val endSec = endSeconds.value.toIntOrNull() ?: 0

                            val startTotalSeconds = (startMin * 60 + startSec).toDouble()
                            val endTotalSeconds = (endMin * 60 + endSec).toDouble()

                            val transcriptInputField =
                                (document.getElementById(Res.Id.transcript) as HTMLTextAreaElement).value
                            val invalidKeywords = keywordsList.filterNot { keyword ->
                                Regex("\\b${Regex.escape(keyword)}\\b", RegexOption.IGNORE_CASE)
                                    .containsMatchIn(transcriptInputField)
                            }
                            val blockedKeywords = keywordsList.filter { keyword ->
                                isDuplicateHighlightByTime(
                                    keyword = keyword,
                                    newStart = startTotalSeconds,
                                    newEnd = endTotalSeconds,
                                    sentences = getSentencesList
                                )
                            }

                            val notesInputField =
                                (document.getElementById(Res.Id.note) as HTMLTextAreaElement).value
                            if (startMinutes.value.isEmpty()) {
                                isStartMinutesError = true
                            } else if (startSeconds.value.isEmpty()) {
                                isStartSecError = true

                            } else if (endMinutes.value.isEmpty()) {
                                isEndMinutesError = true

                            } else if (endSeconds.value.isEmpty()) {
                                isEndSecError = true

                            } else if (transcriptInputField.isEmpty()) {
                                transcriptError = true
                            } else if (keywordsList.isEmpty() && keywordInputText.isEmpty()) {
                                keywordError = true
                                keywordErrorText = "Please add at least one keyword"
                            } else if (keywordsList.isEmpty() && keywordInputText.isNotEmpty()) {
                                keywordError = true
                                keywordErrorText = "Press enter to confirm the keyword"
                            } else if (invalidKeywords.isNotEmpty()) {
                                keywordError = true
                                keywordErrorText =
                                    "These keywords were not found in the transcript: ${
                                        invalidKeywords.joinToString(", ")
                                    }"
                            } else if (blockedKeywords.isNotEmpty()) {
                                keywordError = true
                                keywordErrorText =
                                    "Highlight already exists for this keyword in the selected time range: ${
                                        blockedKeywords.joinToString(", ")
                                    }"
                            } else {
                                try {
                                    isLoading = true
//                                        val startMin = startMinutes.value.toIntOrNull() ?: 0
//                                        val startSec = startSeconds.value.toIntOrNull() ?: 0
//                                        val endMin = endMinutes.value.toIntOrNull() ?: 0
//                                        val endSec = endSeconds.value.toIntOrNull() ?: 0
//
//                                        val startTotalSeconds =
//                                            (startMin * 60 + startSec).toDouble()
//                                        val endTotalSeconds = (endMin * 60 + endSec).toDouble()

                                    val keywordObjects = keywordsList.map { word ->
                                        CustomKeyword(
                                            domainType = sessionData.domainType,
                                            keyWordType = "keyword",
                                            keywordCategory = "custom",
                                            language = sessionData.language,
                                            organization = sessionData.organization,
                                            sessionDateTime = sessionData.sessionDateTime,
                                            sessionID = sessionData.sessionId,
                                            text = word,
                                            usageCount = 0,
                                            userID = sessionData.userId
                                        )
                                    }

                                    val request = CustomHighlightRequest(
                                        domainType = sessionData.domainType,
                                        emotions = "",
                                        endTime = endTotalSeconds,
                                        keywords = keywordObjects,
                                        language = sessionData.language,
                                        organization = sessionData.organization,
                                        sentiment = "",
                                        sessionDateTimes = sessionData.sessionDateTime,
                                        sessionID = sessionData.sessionId,
                                        sessionType = sessionData.sessionType,
                                        startTime = startTotalSeconds,
                                        tone = "",
                                        totalTime = sessionDuration,
                                        transcript = transcriptInputField,
                                        type = "sentence",
                                        userID = sessionData.userId,
                                        wordCount = transcriptInputField.trim()
                                            .split("\\s+".toRegex()).size,
                                        tagPlayers = selectedPlayers.map { it.uid },
                                        tagCoaches = selectedCoach.map { it.userId },
                                        notes = notesInputField,
                                        seasonID = AppGlobal.selectedSeasonId
                                        )

                                    val response = saveCustomHighlight(request)
                                    if (response.message == "Data added successfully!") {
                                        isLoading = false
                                        toastMessageCall("Custom Highlight saved successfully.")
                                        showToast("toastSuccess")
                                        onSave()
                                        clearFields()
                                    } else {
                                        isLoading = false
                                        toastMessageCall("Custom Highlight failed to save.")
                                        showToast("toastError")
                                    }
                                } catch (e: Exception) {
                                    console.error("Failed to save highlight: ${e.message}")
                                    toastMessageCall("Something went wrong.")
                                }
                            }
                        }
                    },
                    width = 80.px,
                    height = 32.px
                )
            }
        }
    }
}




